module.exports = __webpack_public_path__ + "static/media/boy-cook.00cff006.png";